import type { CeoBankBalanceHistoryRow } from '@shared/api';
import { BALANCE_SOURCE_LABELS, formatDateRu, formatMoney } from '../ceoFormat';
import {
  AccountMonoText,
  ClosingBalanceCell,
  DateCell,
  HeaderRow,
  HistorySubtext,
  InflowHistoryCell,
  OutflowHistoryCell,
  Section,
  SourceText,
  Table,
  TableWrap,
  Title,
} from './styles';

interface BalanceHistorySectionProps {
  history: CeoBankBalanceHistoryRow[];
}

export function BalanceHistorySection({ history }: BalanceHistorySectionProps) {
  if (history.length === 0) return null;

  return (
    <Section>
      <HeaderRow>
        <div>
          <Title>Динамика остатков по банковским счетам (последние 14 дней)</Title>
          <HistorySubtext>
            Ежедневные снимки входящих/исходящих остатков и оборотов по API банков и выпискам 1С
          </HistorySubtext>
        </div>
      </HeaderRow>
      <TableWrap>
        <Table>
          <thead>
            <tr>
              <th>Дата снимка</th>
              <th>Банк / Расчётный счёт</th>
              <th>Входящий остаток</th>
              <th>Поступления (+)</th>
              <th>Списания (−)</th>
              <th>Исходящий остаток</th>
              <th>Источник</th>
            </tr>
          </thead>
          <tbody>
            {history.slice(0, 28).map((row) => (
              <tr key={row.id}>
                <DateCell>{formatDateRu(row.snapshot_date)}</DateCell>
                <td>
                  <div>{row.bank_name ?? 'Банковский счёт'}</div>
                  <AccountMonoText>{row.account_number ?? ''}</AccountMonoText>
                </td>
                <td>{formatMoney(row.opening_balance)}</td>
                <InflowHistoryCell $hasInflow={row.inflow_amount > 0}>
                  {row.inflow_amount > 0 ? `+${formatMoney(row.inflow_amount)}` : '0 ₽'}
                </InflowHistoryCell>
                <OutflowHistoryCell $hasOutflow={row.outflow_amount > 0}>
                  {row.outflow_amount > 0 ? `−${formatMoney(row.outflow_amount)}` : '0 ₽'}
                </OutflowHistoryCell>
                <ClosingBalanceCell>{formatMoney(row.closing_balance)}</ClosingBalanceCell>
                <td>
                  <SourceText>{BALANCE_SOURCE_LABELS[row.source] ?? row.source}</SourceText>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableWrap>
    </Section>
  );
}
